module.exports = __webpack_public_path__ + "static/media/18ECA12.fcf4469e.jpg";